import React from 'react';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { useIsIssueViewModalOpen } from '@atlassian/jira-issue-view-modal-state/src/index.tsx';
import { useRovoExperienceAPIStore } from '@atlassian/rovo-experience-api';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { AiRovoButtonWrapperRefresh } from './AiRovoButtonWrapperRefresh.tsx';
import { useIsGlobalRovoButtonAvailableForRoute } from './useIsGlobalRovoButtonAvailableForRoute.tsx';
import { useShouldShowRovoButton } from './useShouldShowRovoButton.tsx';

export const GlobalAiRovoButton = (): React.JSX.Element | null => {
	const isRovoAvailableForRoute = useIsGlobalRovoButtonAvailableForRoute();
	const showRovoButton = useShouldShowRovoButton();
	const [isIssueViewModalOpen] = useIsIssueViewModalOpen();
	const { mode: rovoMode } = useRovoExperienceAPIStore();
	const shouldShowPlaceholder = isIssueViewModalOpen && rovoMode !== 'sidebar';

	if (!isRovoAvailableForRoute || !showRovoButton) {
		return null;
	}

	return (
		<UFOSegment name="rovo-button">
			{shouldShowPlaceholder ? (
				<Box aria-hidden xcss={styles.placeholder} />
			) : (
				<AiRovoButtonWrapperRefresh />
			)}
		</UFOSegment>
	);
};

const styles = cssMap({
	placeholder: {
		width: '48px',
		height: '48px',
	},
});
